import React from "react";
import {
  MOBILE_WIDTH,
  PRACTICE_EDITION_WHITELABEL,
} from "../../../../constants/constants";
import useWindowDimensions from "../../../../components/custom-hooks/useWindowDimensions";
import { rcsIconMain } from "../../../../assets/svg";
import "./styles.scss";

const NewBroadcastMob = (props) => {
  const { width } = useWindowDimensions();

  const options = ["Patient", "Employee", "Appointment", "Template"].filter(
    (item) =>
      (item !== "Employee" || !PRACTICE_EDITION_WHITELABEL) &&
      (width > MOBILE_WIDTH || item !== "Template")
  );

  const handleItemClick = (item) => {
    if (item === "Patient") {
      props.handleChange("patient");
    } else if (item === "Employee") {
      props.handleChange("employee");
    } else if (item === "Appointment") {
      props.handleChange("apiPatient");
    }
  };

  const items = options.map((option, index) => {
    return (
      <>
        <div className="option-item" onClick={() => handleItemClick(option)}>
          {option}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="side-icon"
          >
            <path
              d="m9.705 6-1.41 1.41 4.58 4.59-4.58 4.59L9.705 18l6-6-6-6z"
              fill="#BEBFC0"
            />
          </svg>
        </div>
        {index < 2 && <div class="divider-line" />}
      </>
    );
  });
  return (
    <div className="new-broadcast-container">
      <div className="new-broadcast-title-row">
        <span className="new-broadcast-heading">New Broadcast</span>
        {props.isRcsEnabledForBroadcast && (
          <span className="mobile-rcs-badge">
            {rcsIconMain}
            <span className="mobile-rcs-badge-text">RCS Enabled</span>
          </span>
        )}
      </div>
      <span className="new-broadcast-sub-heading">
        Select a broadcast target to create new broadcast
      </span>
      <div className="item-group">{items}</div>
      <div className="broadcast-report">
        <span onClick={props.showReports}>View Broadcast Report</span>
        <span className="divider-icon">|</span>
        <span onClick={props.showMessageLogs}>View Message Log</span>
        <span className="divider-icon">|</span>
        <span onClick={props.showAdjustThrottle}>View Adjust Throttle</span>
      </div>
    </div>
  );
};

export default NewBroadcastMob;
